import {match} from 'ts-pattern';

import {BillingInformationField} from '@dms/api/sales';

export function getBillingInformationFieldTranslationKey(field: BillingInformationField) {
  return match(field)
    .with('companyName', () => 'entity.customer.labels.companyName')
    .with('registrationNumber', () => 'entity.businessInfo.labels.registrationNumber')
    .with('vatNumber', () => 'entity.businessInfo.labels.vatNumber')
    .with('fileNumber', () => 'entity.businessInfo.labels.fileNumber')
    .with('address.addressLine1', () => 'entity.address.labels.addressLine1')
    .with('address.addressLine2', () => 'entity.address.labels.addressLine2')
    .with('address.zip', () => 'entity.address.labels.zipCode')
    .with('address.city', () => 'entity.address.labels.city')
    .with('address.countryCode', () => 'entity.address.labels.countryCode')
    .with('bankAccount.bankName', () => 'entity.bank.labels.name')
    .with('bankAccount.accountNumber', () => 'entity.bankAccount.labels.number')
    .with('bankAccount.swiftBic', () => 'entity.bankAccount.labels.swiftBic')
    .with('bankAccount.iban', () => 'entity.bankAccount.labels.iban')
    .otherwise(() => field);
}
